/* eslint-disable @typescript-eslint/no-explicit-any */
import "moment/locale/es";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import PaymentView from "../../components/UI/payment-view";

const Confirmar = ({ form, setForm, user, data, commission }: any) => {

  return (
    <div className="min-h-screen bg-gray-50">
      <PaymentView
        form={form}
        setForm={setForm}
        data={data}
        user={user}
        commission={commission}
      />
    </div>
  )
};

export default Confirmar;
